"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = setSuggestedActions;
exports.SET_SUGGESTED_ACTIONS = void 0;
var EMPTY_ARRAY = [];
var SET_SUGGESTED_ACTIONS = 'WEB_CHAT/SET_SUGGESTED_ACTIONS';
exports.SET_SUGGESTED_ACTIONS = SET_SUGGESTED_ACTIONS;

function setSuggestedActions() {
  var suggestedActions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_ARRAY;
  return {
    type: SET_SUGGESTED_ACTIONS,
    payload: {
      suggestedActions: suggestedActions
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL3NldFN1Z2dlc3RlZEFjdGlvbnMuanMiXSwibmFtZXMiOlsiRU1QVFlfQVJSQVkiLCJTRVRfU1VHR0VTVEVEX0FDVElPTlMiLCJzZXRTdWdnZXN0ZWRBY3Rpb25zIiwic3VnZ2VzdGVkQWN0aW9ucyIsInR5cGUiLCJwYXlsb2FkIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUEsSUFBTUEsV0FBVyxHQUFHLEVBQXBCO0FBRUEsSUFBTUMscUJBQXFCLEdBQUcsZ0NBQTlCOzs7QUFFZSxTQUFTQyxtQkFBVCxHQUE2RDtBQUFBLE1BQWhDQyxnQkFBZ0MsdUVBQWJILFdBQWE7QUFDMUUsU0FBTztBQUNMSSxJQUFBQSxJQUFJLEVBQUVILHFCQUREO0FBRUxJLElBQUFBLE9BQU8sRUFBRTtBQUFFRixNQUFBQSxnQkFBZ0IsRUFBaEJBO0FBQUY7QUFGSixHQUFQO0FBSUQiLCJzb3VyY2VSb290IjoiY29yZTovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBFTVBUWV9BUlJBWSA9IFtdO1xuXG5jb25zdCBTRVRfU1VHR0VTVEVEX0FDVElPTlMgPSAnV0VCX0NIQVQvU0VUX1NVR0dFU1RFRF9BQ1RJT05TJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gc2V0U3VnZ2VzdGVkQWN0aW9ucyhzdWdnZXN0ZWRBY3Rpb25zID0gRU1QVFlfQVJSQVkpIHtcbiAgcmV0dXJuIHtcbiAgICB0eXBlOiBTRVRfU1VHR0VTVEVEX0FDVElPTlMsXG4gICAgcGF5bG9hZDogeyBzdWdnZXN0ZWRBY3Rpb25zIH1cbiAgfTtcbn1cblxuZXhwb3J0IHsgU0VUX1NVR0dFU1RFRF9BQ1RJT05TIH07XG4iXX0=